export const VARIANCE_TYPE = {
    AMOUNT: 'AMOUNT',
    PERCENTAGE: 'PERCENTAGE',
};

export const VARIANCE_DISPLAY_FORMAT = {
    AMOUNT: 'AMOUNT',
    PERCENTAGE: 'PERCENTAGE',
};
